import { __require as requireWithSelector } from "../vendor/use-sync-external-store/shim/with-selector.js";
var withSelectorExports = requireWithSelector();
export {
  withSelectorExports as w
};
//# sourceMappingURL=with-selector.js.map
